import { render, staticRenderFns } from "./workerWage.vue?vue&type=template&id=789b8720&"
import script from "./workerWage.vue?vue&type=script&lang=js&"
export * from "./workerWage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports